import { type FetchWalletMeBalanceNonCustodialParams, useSettings } from '@capsicum/common';

import { useNCWBalance } from '../../balance/hooks/useNCWBalance';
import { type NCWBalanceType } from '../../balance/models/NCWBalance';
import { type UseWalletsBalanceProps, type UseWalletsBalanceType } from '../models/walletBalance';

import { useWalletsBalance } from './useWalletsBalance';

/**
 * @description this hook will decide whether to use useWalletsBalance or useNCWBalance based on isPoblanoEnabled feature flag.
 */

export type NCWBalanceSanitizedType = Omit<NCWBalanceType, 'currencies'> & {
	balances: NCWBalanceType['allBalances'];
	currencies: NCWBalanceType['currenciesArray'];
	isLoading: NCWBalanceType['isPending'];
};

const useNCWBalanceSanitized = (queryParams: FetchWalletMeBalanceNonCustodialParams = {}): NCWBalanceSanitizedType => {
	const result = useNCWBalance({}, queryParams);

	return {
		...result,
		balances: result.allBalances,
		currencies: result.currenciesArray,
		isLoading: result.isPending
	};
};

export const useWalletsBalanceWrapper = (
	props: UseWalletsBalanceProps = {}
): NCWBalanceSanitizedType | UseWalletsBalanceType => {
	const { settings } = useSettings();
	const isPoblanoEnabled = settings?.isPoblanoEnabled ?? false;
	const useBalanceHook = isPoblanoEnabled ? useNCWBalanceSanitized : useWalletsBalance;

	return useBalanceHook(props);
};
